﻿import $ from "jquery";
import { reparseUnobtrusiveValidation } from "../utils/validation.js";

const validators = {
    reglookup: {
        parameters: ["lookupresponsefield", "lookupresponsereg"],
        isValid: function (_value, element, params) {
            return $(element).is('[suppress-lookup-populated-validation]') || (
                !$(element).siblings('[data-response-container]').is(':empty') &&
                $(element).siblings('[data-response-container]').find(`#AddModel_${params.lookupresponsefield}_${params.lookupresponsereg}`).length > 0)
        },
        unpack: function (options) {
            options.rules['reglookup'] = options.params;
            options.messages['reglookup'] = options.message;
        }
    }
};

function setupVehicleLookup(fetchPartialSelector) {
    $('[data-button-type="VehicleLookupButton"]').on('mousedown', function () {
        $(this).siblings(':input').attr('suppress-lookup-populated-validation', true);
    });

    $('[data-button-type="VehicleLookupButton"]').on('click', function () {
        lookupVehicle($(this), fetchPartialSelector);
    });

    $('[name$="VehicleRegistration"]').on('change', function () {
        clearResponse($(this).siblings("[data-response-container]"));
    });
    $(document).on('click', '[data-button-type="DeleteResponse"]', function () {
        clearResponse($(this).closest("[data-response-container]"));
    })

    $('[name$="VehicleRegistration"]').on('keypress', function (event) {
        var regex = new RegExp("^[a-zA-Z0-9]+$");
        var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (regex.test(str)) {
            return true;
        }

        var strregex = new RegExp("^[~`!@#$%^&()_={}\[\]\:;,.\/<>/-+/?]+$");
        if (strregex.test(str)) {
            event.preventDefault();
        }

        return false;
    });
}

function lookupVehicle(triggeringButton, fetchPartialSelector) {
    let regInput = triggeringButton.siblings(':input');
    let responseContainer = triggeringButton.siblings('[data-response-container]');

    regInput.attr('suppress-lookup-populated-validation', true);
    let inputValid = regInput.valid()
    regInput.removeAttr('suppress-lookup-populated-validation');
    if (!inputValid || regInput.val() == '') {
        return;
    }

    regInput.removeClass("input-validation-error");
    let errorMessage = regInput.parent().siblings("[data-valmsg-for]");
    clearErrorMessage(errorMessage);

    let reg = regInput.val();
    toggleDisabled(triggeringButton, true);

    let endpoint = fetchPartialSelector(reg);

    $.ajax(endpoint, {
        method: 'GET',
        success: function (data, _status, _object) {
            handleResponse(data, triggeringButton, regInput, responseContainer, errorMessage);
        },
        error: function (_data, _status, _object) {
            window.location = "/Error";
        }
    });
}

function clearResponse(container) {
    container.siblings('input').removeClass("d-none");
    container.siblings('button').removeClass("d-none");
    container.empty();
    container.addClass("d-none");
}

function toggleDisabled(element, disabled) {
    element.toggleClass("disabled disabled--current", disabled);
}

function handleResponse(data, regInputButton, regInput, responseContainer, errorMessage) {
    toggleDisabled(regInputButton, false);

    if (!data) {
        showErrorMessage(errorMessage, regInput.attr('data-val-no-response'));
        return;
    }

    responseContainer.removeClass("d-none");
    responseContainer.append(data);
    regInputButton.addClass("d-none");
    regInput.addClass("d-none");

    reparseUnobtrusiveValidation();
}

function clearErrorMessage(errorMessage) {
    errorMessage.empty()
        .removeClass('field-validation-error')
        .addClass('field-validation-valid');
}

function showErrorMessage(errorMessage, message) {
    errorMessage.text(message)
        .addClass('field-validation-error')
        .remove('field-validation-valid');
}

export { validators, setupVehicleLookup }